import { render, staticRenderFns } from "./MWrapperFolder.vue?vue&type=template&id=c6db11e8&scoped=true"
import script from "./MWrapperFolder.vue?vue&type=script&lang=js"
export * from "./MWrapperFolder.vue?vue&type=script&lang=js"
import style0 from "./MWrapperFolder.vue?vue&type=style&index=0&id=c6db11e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6db11e8",
  null
  
)

export default component.exports